<template>
  <Layout>
    <template #default>
      <router-view />
    </template>
  </Layout>
  <SkipToContent />
</template>

<script setup lang="ts">
import Layout from './components/layout/Layout.vue';
import SkipToContent from './components/accessibility/SkipToContent.vue';
import { useTopbarStore } from '@/store/topbar';
import { i18n } from '@/plugins/i18n';
import { watch, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useAuthStore } from './store/auth';
import { registerWebComponents } from '@/helpers/webcomponents';

const topbarStore = useTopbarStore();
const { topBar } = storeToRefs(topbarStore);
const authStore = useAuthStore();

const setLanguage = (language: string) => {
  localStorage.setItem('language', language);
  i18n.global.locale.value = language;
};

watch(
  topBar,
  (bar) => {
    if (!bar) return;
    if (bar?.language) {
      setLanguage(bar.language);
    }
    bar.onChangeLanguage = (language: string) => {
      setLanguage(language);
    };
    bar.onLogout = () => {
      authStore.logout();
    };
  },
  { immediate: true }
);

onMounted(() => {
  topbarStore.initTopbar();
  registerWebComponents();
});
</script>
